import { render, staticRenderFns } from "./CardTopUp.vue?vue&type=template&id=bcf8850c&scoped=true&"
import script from "./CardTopUp.vue?vue&type=script&lang=js&"
export * from "./CardTopUp.vue?vue&type=script&lang=js&"
import style0 from "./CardTopUp.vue?vue&type=style&index=0&id=bcf8850c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf8850c",
  null
  
)

export default component.exports